import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { resolveImageUrl } from "@/lib/api";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { content } = useSite();
  const nav = content.navigation || { items: [], cta_enabled: false };
  const theme = content.theme || {};
  const siteTitle = content.seo?.site_title || "SSH Auto Sales";
  const items = (nav.items || []).filter((i) => i.enabled !== false);

  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors duration-150 hover:text-primary ${
      isActive ? "text-primary" : "text-foreground"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="nav-brand">
          {theme.logo_url ? (
            <img src={resolveImageUrl(theme.logo_url)} alt={siteTitle} className="h-9 w-auto object-contain" />
          ) : (
            <span className="font-display text-2xl font-black tracking-tight text-foreground">
              SSH <span className="text-primary">AUTO SALES</span>
            </span>
          )}
        </Link>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation">
          {items.map((l) => (
            <NavLink key={l.id} to={l.url} className={linkCls} data-testid={`nav-link-${l.id}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3 shrink-0">
          {nav.cta_enabled && nav.cta_label && (
            <Link to={nav.cta_url || "/inventory"} className="btn-themed" data-testid="nav-cta-browse">
              {nav.cta_label}
            </Link>
          )}
        </div>

        <button
          className="lg:hidden text-foreground p-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden bg-background border-t border-border px-6 py-6 flex flex-col gap-5" aria-label="Mobile navigation" data-testid="nav-mobile-menu">
          {items.map((l) => (
            <NavLink
              key={l.id}
              to={l.url}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-foreground hover:text-primary"
              data-testid={`nav-link-${l.id}-mobile`}
            >
              {l.label}
            </NavLink>
          ))}
          {nav.cta_enabled && nav.cta_label && (
            <Link
              to={nav.cta_url || "/inventory"}
              onClick={() => setOpen(false)}
              className="btn-themed mt-2"
              data-testid="nav-cta-browse-mobile"
            >
              {nav.cta_label}
            </Link>
          )}
        </nav>
      )}
    </header>
  );
};
